import { useTranslation } from "react-i18next";
import { instructors } from "@/mocks/data";

export default function Instructors() {
  const { t, i18n } = useTranslation();
  const isJa = i18n.language === "ja";
  const inst = instructors[0];

  return (
    <section id="instructors" className="relative bg-deepblack py-24 md:py-36 overflow-hidden">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="mb-16 md:mb-24">
          <span className="text-warmgray text-xs font-sans tracking-widest uppercase block mb-4">
            {t("instructors.label")}
          </span>
          <h2 className="text-marble font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-wide">
            <span>{t("instructors.title1")}</span>
            {t("instructors.title2") && (
              <span className="block italic font-normal mt-1">{t("instructors.title2")}</span>
            )}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="lg:col-span-5">
            <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-charcoal">
              <img
                src={inst.image}
                alt={isJa ? inst.nameJp : inst.name}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deepblack/60 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <span className="inline-block px-3 py-1.5 rounded-full bg-champagne/20 backdrop-blur-sm border border-champagne/30 text-champagne text-[10px] font-sans tracking-widest uppercase">
                  {isJa ? inst.specialtyJp : inst.specialty}
                </span>
              </div>
            </div>
          </div>

          {/* Right: Info */}
          <div className="lg:col-span-7">
            <h3 className="text-marble font-serif text-2xl md:text-3xl lg:text-4xl font-light tracking-wide">
              {isJa ? inst.nameJp : inst.name}
            </h3>
            <p className="text-champagne text-sm font-sans tracking-widest uppercase mt-2 mb-6">
              {isJa ? inst.roleJp : inst.role}
            </p>
            {/* Divider */}
            <div className="w-16 h-px bg-champagne/30 mb-6" />
            <p className="text-warmgray text-sm md:text-base font-sans leading-relaxed whitespace-pre-line">
              {isJa ? inst.bio : (inst as any).bioEn || inst.bio}
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-8">
              <a
                href="https://www.instagram.com/tsingtao_drums/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-5 py-3 rounded-full bg-champagne/10 border border-champagne/25 text-champagne/80 hover:bg-champagne/20 hover:text-champagne hover:border-champagne/40 text-sm font-sans tracking-wide transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-instagram-line text-lg w-5 h-5 flex items-center justify-center" />
                <span>Instagram</span>
                <i className="ri-external-link-line text-xs w-4 h-4 flex items-center justify-center opacity-50" />
              </a>
              <a
                href="https://open.spotify.com/playlist/13Ae4shAXRZJ6qA9Gz292i?si=guL_P5-pRRKdPpHvCkj3qw"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-5 py-3 rounded-full bg-champagne/10 border border-champagne/25 text-champagne/80 hover:bg-champagne/20 hover:text-champagne hover:border-champagne/40 text-sm font-sans tracking-wide transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-spotify-line text-lg w-5 h-5 flex items-center justify-center" />
                <span>Spotify</span>
                <i className="ri-external-link-line text-xs w-4 h-4 flex items-center justify-center opacity-50" />
              </a>
            </div>

            {/* Spotify Playlist */}
            <div className="mt-12">
              <span className="text-warmgray text-xs font-sans tracking-widest uppercase block mb-3">
                {isJa ? "プレイリスト" : "Play List"}
              </span>
              <div className="w-full h-px bg-champagne/30 mb-4" />
              <div className="rounded-lg overflow-hidden border border-champagne/20">
                <iframe
                  src="https://open.spotify.com/embed/playlist/13Ae4shAXRZJ6qA9Gz292i?utm_source=generator&theme=0"
                  width="100%"
                  height="380"
                  allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                  loading="lazy"
                  className="bg-transparent"
                  style={{ border: 0, borderRadius: 0 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}